import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { Game, Mobile, Realty, HomeMegaMenuIcon } from "../../../app-constants";
import Modal from "react-bootstrap/Modal";
import Downloadform from "../components/downloadform";
import { StaticImage } from "gatsby-plugin-image";

function DekstopHeader({ lang }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <nav className="tekrevol_menu deskstop_view desktop-updated text-end">
        <ul>
          <li>
            <Link to="/" className="nav_link" activeClassName="active">
              Home
            </Link>
          </li>
          <li className="mega">
            <Link to="/services" className="nav_link">
              Services
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="">
                    <div className="cateorgy_namee main-title">
                      <h4 className="ps-0">Built to Win</h4>
                      <p>
                        Transforming business with our future-ready tech
                        solutions. Get custom products for accelerated digital
                        transformation across industries globally.
                      </p>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/header/iphone-15-pro-big.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1425}
                          height={921}
                        />
                      </div>
                    </div>
                    {/* <div className="cateorgy_namee"> 
                      <h4 className="ps-0">
                        <Link to="/">
                          Startup
                        </Link>
                      </h4>
                      <h4 className="ps-0">
                        <Link to="/">
                          Public Entities
                        </Link>
                      </h4>                      
                      <h4 className="ps-0">
                        <Link to="/">
                          Enterprises
                        </Link>
                      </h4>                      
                    </div> */}
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/mobile-app-development">
                          Mobile App Development{" "}
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="https://www.tekrevol.com/iphone-app-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> iOS
                            App Development
                          </Link>
                        </li>

                        <li>
                          <Link to="https://www.tekrevol.com/android-app-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Android App development
                          </Link>
                        </li>

                        <li>
                          <Link to="/cross-platform-app-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Cross Platform App Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/game-development">
                          Game Development
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="https://www.tekrevol.com/2d-game-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> 2D
                            Game Development
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/3d-game-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> 3D
                            Game Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/web3-game-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Web3 Game Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/solution/it-staff-augmentation">
                          Staff Augmentation
                        </Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <Link to="/hire-android-app-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Hire Android App Developer
                          </Link>
                        </li>

                        <li>
                          <Link to="/hire-ios-app-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Hire iOS App Developer
                          </Link>
                        </li>

                        <li>
                          <Link to="/hire-nodejs-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Hire NodeJs Developer
                          </Link>
                        </li>
                      </ul>
                    </div>
                    {/* <div className="cateorgy_namee">
                      <h4>Digital Marketing</h4>
                      <ul className="menu_items no-border">
                        <li>
                          <Link to="/">
                            <span className='icon'>{HomeMegaMenuIcon}</span> Search engine optimization
                          </Link>
                        </li>

                        <li>
                          <Link to="/">
                            <span className='icon'>{HomeMegaMenuIcon}</span> Search engine marketing
                          </Link>
                        </li>

                        <li>
                          <Link to="/">
                            <span className='icon'>{HomeMegaMenuIcon}</span> Social media marketing
                          </Link>
                        </li>
                        
                      </ul>
                    </div> */}
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/custom-software-development">
                          Custom Software Development
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <Link to="/solution/erp-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span> ERP
                            solution
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/solution/crm-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span> CRM
                            Solution
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/cms-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> CMS
                            Solution
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/ai-development-company">
                          Artificial Intelligence
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <Link to="https://www.tekrevol.com/generative-ai">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Generative AI
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/natural-language-processing-services">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Natural Language Processing
                          </Link>
                        </li>
                        <li>
                          <Link to="/speech-recognition-software-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Speech Recognition
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/blockchain-app-development">
                          Blockchain Development
                        </Link>
                      </h4>
                      <ul className="menu_items no-border">
                        {/* <li>
                          <Link to="/iot-development">
                            <span className='icon'>{HomeMegaMenuIcon}</span> IOT Development
                          </Link>
                        </li> */}
                        <li>
                          <Link to="/metaverse-development-company">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Metaverse Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/nft-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> NFT
                            Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/web-development">
                          Web Development
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        {/* <li>
                          <Link to="/">
                            <span className='icon'>{HomeMegaMenuIcon}</span> Custom Website Development
                          </Link>
                        </li> */}
                        <li>
                          <Link to="https://www.tekrevol.com/ecommerce-website-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Ecommerce Website Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/web-portal-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> Web
                            Portals
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/cloud-consulting-services">
                          Cloud Services
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="https://www.tekrevol.com/cloud-application-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Cloud Application Development
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/cloud-migration">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Cloud Migration
                          </Link>
                        </li>
                        <li>
                          <Link to="/cloud-support-and-maintenance">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Cloud Support & Maintenance
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/digital-marketing-agency">
                          Digital Marketing Services
                        </Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <Link to="https://www.tekrevol.com/social-media-marketing-services">
                            <span className="icon">{HomeMegaMenuIcon}</span>
                            Social Media Marketing
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/search-engine-marketing">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Search Engine Marketing
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.tekrevol.com/search-engine-optimization">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Search Engine Optimization
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          <li className="mega">
            <Link to="/" className="nav_link">
              Industries{" "}
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="">
                    <div className="cateorgy_namee main-title">
                      <h4 className="ps-0">Built to Win</h4>
                      <p>
                        Transforming business with our future-ready tech
                        solutions. Get custom products for accelerated digital
                        transformation across industries globally.
                      </p>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/header/iphone-15-pro-big.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1425}
                          height={921}
                        />
                      </div>
                    </div>
                    {/* <div className="cateorgy_namee"> 
                      <h4 className="ps-0">
                        <Link to="/">
                          Startup
                        </Link>
                      </h4>
                      <h4 className="ps-0">
                        <Link to="/">
                          Public Entities
                        </Link>
                      </h4>                      
                      <h4 className="ps-0">
                        <Link to="/">
                          Enterprises
                        </Link>
                      </h4>                      
                    </div> */}
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/solution/automotive-app-development">
                          Automotive
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <p>
                            Transforming automotive industry with bespoke tech.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/solution/educational-software-company">
                          Education
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <p>Enhancing education with new-age EdTech.</p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/solution/real-estate-app-development">
                          Real Estate
                        </Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <p>Innovating real estate with custom tech.</p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/solution/logistics-software-development">
                          Logistics
                        </Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>Optimizing logistics with intelligent tech.</p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/healthcare-app-development">
                          Healthcare
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>
                            Better, accessible healthcare through tailored tech
                            solutions.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/solution/music-app-developers">
                          Music
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>
                            Advancing music industry with digital innovations.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/saas-video-production">SAAS</Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>Developing custom solutions for SAAS platforms.</p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/solution/retail-software-solution">
                          Retail
                        </Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>
                            Scaling retail businesses through advanced
                            technology.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/on-demand-app-development">
                          On-Demand
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>
                            Elevating on-demand services with innovative tech.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="https://www.tekrevol.com/solution/ecommerce-app-development">
                          eCommerce
                        </Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>Driving e-commerce growth with smart tech.</p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/fintech-software-development">Fintech</Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>
                            Empowering fintech with specialized tech services.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          <li className="mega">
            <Link to="/technologies" className="nav_link">
              Technologies{" "}
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="">
                    <div className="cateorgy_namee main-title">
                      <h4 className="ps-0">Built to Win</h4>
                      <p>
                        Transforming business with our future-ready tech
                        solutions. Get custom products for accelerated digital
                        transformation across industries globally.
                      </p>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/header/iphone-15-pro-big.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1425}
                          height={921}
                        />
                      </div>
                    </div>
                    {/* <div className="cateorgy_namee"> 
                      <h4 className="ps-0">
                        <Link to="/">
                          Startup
                        </Link>
                      </h4>
                      <h4 className="ps-0">
                        <Link to="/">
                          Public Entities
                        </Link>
                      </h4>                      
                      <h4 className="ps-0">
                        <Link to="/">
                          Enterprises
                        </Link>
                      </h4>                      
                    </div> */}
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Languages</h4>
                      <ul className="menu_items no-border">
                        <li>
                          <Link to="/dot-net-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            .Net
                          </Link>
                        </li>

                        <li>
                          <Link to="/html5-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            HTML5
                          </Link>
                        </li>

                        <li>
                          <Link to="/java-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Java
                          </Link>
                        </li>

                        <li>
                          <Link to="/hire-nodejs-developers">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Node.Js
                          </Link>
                        </li>

                        <li>
                          <Link to="/php-development">
                            <span className="icon">{HomeMegaMenuIcon}</span> PHP
                          </Link>
                        </li>

                        <li>
                          <Link to="/python-development">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Python
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Platforms</h4>
                      <ul className="menu_items no-border">
                        <li>
                          <Link to="/azure-consultant">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Azure
                          </Link>
                        </li>
                        <li>
                          <Link to="/gcp-cloud">
                            <span className="icon">{HomeMegaMenuIcon}</span> GCP
                          </Link>
                        </li>
                        <li>
                          <Link to="/oracle-solution">
                            <span className="icon">{HomeMegaMenuIcon}</span>{" "}
                            Oracle
                          </Link>
                        </li>
                        <li>
                          <Link to="/sap-consultant">
                            <span className="icon">{HomeMegaMenuIcon}</span> SAP
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}></Col>
                </Row>
              </Container>
            </div>
          </li>

          <li className="mega">
            <Link to="#" className="nav_link">
              Insights
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="">
                    <div className="cateorgy_namee main-title">
                      <h4 className="ps-0">Built to Win</h4>
                      <p>
                        Transforming business with our future-ready tech
                        solutions. Get custom products for accelerated digital
                        transformation across industries globally.
                      </p>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/header/iphone-15-pro-big.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1425}
                          height={921}
                        />
                      </div>
                    </div>
                    {/* <div className="cateorgy_namee"> 
                      <h4 className="ps-0">
                        <Link to="/">
                          Startup
                        </Link>
                      </h4>
                      <h4 className="ps-0">
                        <Link to="/">
                          Public Entities
                        </Link>
                      </h4>                      
                      <h4 className="ps-0">
                        <Link to="/">
                          Enterprises
                        </Link>
                      </h4>                      
                    </div> */}
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/about">About TekRevol</Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <p>
                            Empowering startups and enterprises with custom
                            digital solutions for transformation.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/press-release">Press</Link>
                      </h4>
                      <ul className="menu_items">
                        <li>
                          <p>
                            Get the latest news and updates about TekRevol’s
                            impact.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <a href="https://www.tekrevol.com/blogs/partnership-program/">
                          Referral Program
                        </a>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>Refer talent to TekRevol and earn rewards.</p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/life-at-tekrevol">Life At TekRevol</Link>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>
                            Join our inclusive, dynamic tech team. Grow,
                            innovate, and thrive with us.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/podcast">Podcast</Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>
                            Listen to expert talks on tech and digital
                            transformation.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>
                        <a href="https://www.tekrevol.com/blogs/">Blogs</a>
                      </h4>
                      <ul className="menu_items ">
                        <li>
                          <p>
                            Explore insights and trends in tech with our
                            expert-written blogs.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="cateorgy_namee">
                      <h4>
                        <Link to="/events">Events</Link>
                      </h4>
                      <ul className="menu_items no-border">
                        <li>
                          <p>
                            Attend our events and webinars to learn and network.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          <li className="mega">
            <Link to="/projects" className="nav_link">
              Portfolio
            </Link>
          </li>
          {lang === "arbic_dubai" ? (
            <li>
              <Link
                to="/mobile-app-development-company-dubai"
                className="nav_link"
              >
                EN
              </Link>
            </li>
          ) : lang === "eng_dubai" ? (
            <li>
              <Link to="/ar/تصميم-تطبيقات-الجوال-في-دبي" className="nav_link">
                عربي
              </Link>
            </li>
          ) : lang === "arbic_saudi" ? (
            <li>
              <Link
                to="/sa/mobile-apps-development-in-saudi-arabia"
                className="nav_link"
              >
                EN
              </Link>
            </li>
          ) : lang === "eng_saudi" ? (
            <li>
              <Link
                to="/sa/تصميم-تطبيقات-الجوال-في-السعودية"
                className="nav_link"
              >
                عربي
              </Link>
            </li>
          ) : (
            ""
          )}
          <li>
            <Link
              to="/contact"
              className="btn_primary"
              aria-label="TekRevol Contact"
            >
              Get A Quote
            </Link>
          </li>
        </ul>
      </nav>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal_forms">
          <Downloadform setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default DekstopHeader;
